import React from "react";
import { Grid } from "@mui/material";
import LabeledSelect from "../../Widgets/LabeledSelect";
import LabeledTextArea from "../../Widgets/LabeledTextArea";
import { InterventionHistoryFormValues } from "./interface";

interface EditFieldsProps {
  formValues: InterventionHistoryFormValues;
  handleChange: (
    field: keyof InterventionHistoryFormValues
  ) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleMultiChange: (field: keyof InterventionHistoryFormValues) => (value: string[]) => void;
}

const BARRIERS_OPTIONS = [
  { value: "ON_WAITLIST_FOR_IN_PERSON_SERVICES", label: "On Waitlist for In-Person Services" },
  { value: "AREA_LACKS_ABA_THERAPY", label: "Area Lacks ABA Therapy" },
  { value: "LACKS_RELIABLE_TRANSPORTATION", label: "Lacks Reliable Transportation" },
  { value: "INSURANCE_NOT_ACCEPTED_BY_LOCAL_PROVIDERS", label: "Insurance Not Accepted by Local Providers" },
  { value: "MEDICAL_CHALLENGES_RENDER_IN_PERSON_UNSAFE", label: "Medical Challenges Render In-Person Unsafe" },
  { value: "LOCAL_PROVIDERS_LACK_PREFERRED_LANGUAGE", label: "Local Providers Lack Preferred Language" },
  { value: "LOCAL_PROVIDERS_CANNOT_APPROPRIATELY_SERVE", label: "Local Providers Cannot Appropriately Serve" },
];

export const EditFields: React.FC<EditFieldsProps> = ({ formValues, handleChange, handleMultiChange }) => {
  return (
    <Grid container spacing={7}>
      <LabeledSelect
        label="Has the client ever received ABA therapy in the past?"
        value={formValues.hasReceivedServices}
        onChange={handleChange("hasReceivedServices")}
        options={[
          { label: "Yes", value: "YES" },
          { label: "No", value: "NO" },
          { label: "Unknown", value: "UNKNOWN" },
        ]}
      />
      {formValues.hasReceivedServices === "YES" && (
        <LabeledTextArea
          label="Why were previous ABA therapy services discontinued?"
          value={formValues.previousServicesDiscontinuationReason}
          onChange={handleChange("previousServicesDiscontinuationReason")}
          placeholder="Describe why the client's previous ABA therapy services ended."
          multiline
          minRows={3}
        />
      )}
      <LabeledSelect
        multiple
        label="Specific barriers preventing the client from accessing services"
        value={formValues.accessBarriers}
        onChange={handleMultiChange("accessBarriers")}
        options={BARRIERS_OPTIONS}
      />
    </Grid>
  );
};

export default EditFields;
